export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      users: [
        {
          userUuid: '1b2c6a69f00ab0ea7583ce9b3c58b4a7',
          name: '運営者 三郎',
          email: 'aaa@aaa.com',
          roleKbn: 2,
          service: {
            serviceUuid: 'services003',
            serviceName: '☓☓地域サポート'
          },
          linkedCmss: [
            {
              linkCMSMstId: 4,
              linkCMSName: 'ボット管理CMS',
              linkCMSURL: 'https://xxx.xxx.xxx'
            }
          ],
          status: 1,
          lastLoginAt: 1594880785395
        },
        {
          userUuid: '1b2c6a69f00ab0ea7583ce9b3c58b4a6',
          name: '運営者 次郎',
          email: 'aaa@aaa.com',
          roleKbn: 2,
          service: {
            serviceUuid: 'services002',
            serviceName: '〇〇地域サポート'
          },
          linkedCmss: [
            {
              linkCMSMstId: 2,
              linkCMSName: 'バス予約管理CMS',
              linkCMSURL: 'https://xxx.xxx.xxx'
            }
          ],
          status: 0,
          lastLoginAt: 1594880785395
        },
        {
          userUuid: '1b2c6a69f00ab0ea7583ce9b3c58b4a5',
          name: '運営者 太郎',
          email: 'aaa@aaa.com',
          roleKbn: 2,
          service: {
            serviceUuid: 'services001',
            serviceName: 'アイラ地域サポート'
          },
          linkedCmss: [
            {
              linkCMSMstId: 1,
              linkCMSName: 'レストラン予約CMS',
              linkCMSURL: 'https://xxx.xxx.xxx'
            },
            {
              linkCMSMstId: 3,
              linkCMSName: '配信管理CMS',
              linkCMSURL: 'https://xxx.xxx.xxx'
            }
          ],
          status: 1,
          lastLoginAt: 1594880785395
        }
      ]
    }
  }
}